const COVAL_EMAIL_DOMAIN = "coval.dev"

export function hasCovalAdminAccess(value: unknown): boolean {
  if (
    typeof value !== "object" ||
    value === null ||
    !("emailAddress" in value) ||
    typeof value.emailAddress !== "string" ||
    !("verification" in value) ||
    typeof value.verification !== "object" ||
    value.verification === null ||
    !("status" in value.verification) ||
    value.verification.status !== "verified"
  ) {
    return false
  }

  const normalizedEmail = value.emailAddress.trim().toLowerCase()
  const emailParts = normalizedEmail.split("@")
  return (
    emailParts.length === 2 &&
    Boolean(emailParts[0]) &&
    emailParts[1] === COVAL_EMAIL_DOMAIN &&
    !emailParts[0].includes("+clerk_test")
  )
}
